export const environment = {
  api_endpoint: import.meta.env.API_ENDPOINT,
  appId: import.meta.env.APP_ID,
  auth_endpoint: import.meta.env.AUTH_ENDPOINT,
  defaultauth: import.meta.env.DEFAULT_AUTH,
  environment_name: import.meta.env.ENVIRONMENT,
  external_urls: [{
    name: "dev",
    url: "https://dashboard.dev.culliganiot.com/admin",
    active: true
  }, {
    name: "tst",
    url: "https://dashboard.test.culliganiot.com/admin",
    active: true
  }, {
    name: "prd",
    url: "https://dashboard.culliganiot.com/admin",
    active: true
  }],
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: ""
  },
  googleMaps: {
    apiKey: import.meta.env.GOOGLE_MAPS_API_KEY
  },
  mode: import.meta.env.MODE,
  model: import.meta.env.MODEL,
  models: import.meta.env.MODELS,
  production: import.meta.env.MODE === "production" ? true : false,
  datadogAppId: import.meta.env.DATADOG_APP_ID,
  datadogClientToken: import.meta.env.DATADOG_CLIENT_TOKEN,
  datadogEnv: import.meta.env.ENVIRONMENT
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.